import { Class } from "@webhare-system/frameworks/mootools/core";
var $todd = require("./support");
var autocomplete = require("@webhare-system/internal/autocomplete");

/****************************************************************************************************************************
 *                                                                                                                          *
 *  TOLLIUM AUTOCOMPLETE SERVICE                                                                                            *
 *                                                                                                                          *
 ****************************************************************************************************************************/
$todd.AutoCompleteService = new Class(
{ Extends: autocomplete.AutoCompleteService

, options: { url: "/wh_services/tollium/autocomplete"
           , rpccall: "AutoComplete"
           , ac_port: ""
           }

/****************************************************************************************************************************
 * Initialization
 */

, initialize: function(options)
  {
    this.parent(options);
  }

/****************************************************************************************************************************
 * Internal
 */

, getRPCArguments: function(query)
  {
    return [ this.options.ac_port, query ];
  }

});



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/autocomplete.es